import isAllowedHost from './isAllowedHost'

const redirectToUrl = (url: string): void => {
  if (isAllowedHost(url)) {
    window.location.href = url
  }
}

export default redirectToUrl
